// GENERATED FILE -- do not edit by hand.
// Source of truth: release-manifest.json (repository root). Regenerated by
// `npm run sync:release`, which every `npm run check`/`npm run build` runs first.
export const GAME_ID = "wild_blooms";
export const GAME_CORE_VERSION = "1.3.0";
export const API_VERSION = "v1";
export const LEGACY_VERSION = "v405";
//# sourceMappingURL=version.generated.js.map